import { MkmModel } from "./mkm.model";


export class TzadikimModel {
    id!: number;
    title!: string;
    subTitle!: string;
    tzadikTitle!: string;
    tzadikFirstName!: string;
    tzadikBN!: string;
    fathersTitle!: string;
    fatherName!: string;
    tzadikEndTitle!: string;
    nlYear!: string;
    nlMonth!: string;
    nlDay!: string;
    nfYear!: string;
    nfMonth!: string;
    nfDay!: string;
    mchs!: string;
    toldes!: string;
    tfilis!: string;
    mkmId!: number;
    mkm: MkmModel;
    images!: string;
    cityY!: string;
    stateY!: string;

    constructor() {
        this.mkm = new MkmModel();
    }



}